import { render, staticRenderFns } from "./UpsertElementTypeModal.vue?vue&type=template&id=1dc5a1e7&scoped=true&"
import script from "./UpsertElementTypeModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertElementTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpsertElementTypeModal.vue?vue&type=style&index=0&id=1dc5a1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc5a1e7",
  null
  
)

export default component.exports